/* eslint-disable no-undef */
import React from 'react'
import { connect } from 'react-redux';
import { getIcon } from '../../Components/Functions';
import { routers } from '../../Constants/routers';
import { login } from '../../Redux/User/actions';
import Api from '../../Server/Api';
import AuthLayout from './AuthLayout'

const api = new Api();

export const PasswordReset = (props) => {
  const username = React.useRef(null);
	const [loading, setLoading] = React.useState(false);
  const [message, setMessage] = React.useState();
  const [messageType, setMessageType] = React.useState(false);

	const [data, setData] = React.useState({});

	const _login = async () => {
		if (!data?.username) {
			notyf.open({
				type: "error",
				message: "Please enter your email registered address to continue.",
			});
			return;
		}
		setLoading(true);
		const res = await api.post({ endpoint: `/users/password_reset_request/`, data: { email: data?.username } });
      let time = 15
      setMessage(res?.detail || res?.message || "Unknown error message.")
      setMessageType(res?.status)
      const interval = setInterval(() => {
        if(time < 1) {
          clearInterval(interval);
          setMessage();
        }
        time--;
      }, 1000);
		setLoading(false);
	};


	React.useEffect(() => {
		setData({
			username: username?.current?.value,
		});
	}, []);
    
    return (
        <div className="form-card">
        <form>
        <div id="signin-form" className="login-form">
        {message && (
								<div
									className={`message is-${messageType ? "success" : "danger"}`}
								>
									<div
										class="message-body"
										dangerouslySetInnerHTML={{ __html: message }}
									/>
								</div>
							)}

          {/* Input */}
          <div className="field">
            <div className="control has-icon">
              <input ref={username} className="input" type="text" placeholder="Email address"
                onInput={(e) =>
                    setData({ ...data, username: e.target.value })
                }
              />
              <span className="form-icon" dangerouslySetInnerHTML={{ __html: getIcon("mail") }} />
            </div>
          </div>
    
          <div className="control login">
            <button type="button" className={`button h-button is-primary is-bold is-fullwidth is-raised ${loading ? "is-loading" : ""}`}
                onClick={() => _login()}
            >
              Send Reset Link
            </button>
          </div>
        </div>
      </form>
      </div>
    )
}


const PasswordResetRequest = (props) => {
    return (
        <AuthLayout>
           <PasswordReset {...props} />
           <div className="forgot-link has-text-centered">
            <a href={routers.auth.login}
              style={{ alignItems: "center", display: "flex" }}
              dangerouslySetInnerHTML={{ __html: getIcon("chevron-left")+" <span>Back to Login</span>" }}
            />
          </div>
        </AuthLayout>
    )
}


const mapStateToProps = ({ user }) => {
	return { user };
};

const mapDispatchToProps = (dispatch) => {
	return { login: (e) => dispatch(login(e)) };
};

export default connect(mapStateToProps, mapDispatchToProps)(PasswordResetRequest);